import { PrivateRoute } from 'components/route'
import { AcessoCbo, SexoEnum } from 'graphql/types.generated'
import React from 'react'
import { FormSpy } from 'react-final-form'
import { Switch, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import AtestadoView from './atestados/AtestadosView'
import { DeclaracaoComparecimentoFormView } from './declaracao-comparecimento/DeclaracaoComparecimentoFormView'
import { PlanoFormModel } from './PlanoForm'
import PrescricaoMedicamentoView from './prescricao-medicamento/PrescricaoMedicamentoView'

export interface PlanoRootViewProps {
  name: MetaPath<PlanoFormModel>
  prontuarioId: ID
  atendimentoId: ID
  cidadao: CidadaoAtendimento
  dataAtendimento: Instant
  cidadaoDataNascimento: LocalDate
  cidadaoSexo: SexoEnum
}

export default function PlanoRootView(props: PlanoRootViewProps) {
  const match = useRouteMatch()
  const { name, prontuarioId, cidadao, atendimentoId, dataAtendimento, cidadaoDataNascimento, cidadaoSexo } = props

  return (
    <>
      <FormSpy subscription={{ values: true, pristine: true }}>
        {(soap) => (
          <Switch>
            <PrivateRoute
              path={`${match.url}/atestados`}
              permission={Permissions.visualizarProntuario.soap.plano.visualizarAtestados}
            >
              <AtestadoView
                name={name.atestado}
                atendimentoId={atendimentoId}
                prontuarioId={prontuarioId}
                cidadao={cidadao}
                dataAtendimento={dataAtendimento}
              />
            </PrivateRoute>
            <PrivateRoute
              path={`${match.url}/declaracaoComparecimento`}
              permission={Permissions.visualizarListaDeAtendimento.gerarDeclaracaoDeComparecimento}
            >
              <DeclaracaoComparecimentoFormView atendId={atendimentoId} />
            </PrivateRoute>
            <PrivateRoute
              path={`${match.url}/prescricao-medicamentos`}
              permission={[
                AcessoCbo.AUXILIAR_OU_TECNICO_ENFERMAGEM,
                AcessoCbo.CIRURGIAO_DENTISTA,
                AcessoCbo.ENFERMEIRO,
                AcessoCbo.MEDICO,
                AcessoCbo.OUTRO_PROF_NIVEL_SUPERIOR,
                AcessoCbo.TSB,
              ]}
            >
              <PrescricaoMedicamentoView
                name={name.prescricaoMedicamento}
                prontuarioId={prontuarioId}
                atendimentoId={atendimentoId}
                medicamentos={soap.values?.plano?.prescricaoMedicamento?.medicamentos}
                cidadaoDataNascimento={cidadaoDataNascimento}
                cidadaoSexo={cidadaoSexo}
              />
            </PrivateRoute>
          </Switch>
        )}
      </FormSpy>
    </>
  )
}
